import { render, staticRenderFns } from "./ParentsNews.vue?vue&type=template&id=ca89fde6&"
import script from "./ParentsNews.vue?vue&type=script&lang=js&"
export * from "./ParentsNews.vue?vue&type=script&lang=js&"
import style0 from "./ParentsNews.vue?vue&type=style&index=0&id=ca89fde6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports